{
  "d": "Democratic",
  "dr": "Democratic-Republican",
  "f": "Federalist",
  "n": "none",
  "nu": "National Union",
  "r": "Republican",
  "w": "Whig",
  "wd": "Whig & Democratic"
}
